import { h } from 'preact'

type TopicType = {
  ideationStatus?: {
    name: string,
    bgColor: string,
    color: string
  },
  ideaStatus?: {
    name: string,
    backgroundColor: string,
    textColor: string
  }
}

const IdeationStatus = ({ topic }: { topic: TopicType }) => {
  if (!topic.ideationStatus && !topic.ideaStatus) {
    return null
  }

  let IdeaStatus = Object.assign({ bgColor: '', color: '', name: '' }, topic.ideationStatus)

  if (topic.ideaStatus) {
    IdeaStatus.bgColor = `#${topic.ideaStatus.backgroundColor}`
    IdeaStatus.color = `#${topic.ideaStatus.textColor}`
    IdeaStatus.name = topic.ideaStatus.name
  }

  const { name, bgColor, color } = IdeaStatus

  return (
    <span
      style={{ color: color, backgroundColor: bgColor }}
      class={'pill pill_idea pill--uppercase'}>
      { name }
    </span>
  )
}

export default IdeationStatus
